import React from 'react';
import Node, {
  NodeProps,
} from 'components/canvas/components/nodes/components/base-node';
import NodeHeader from 'components/canvas/components/nodes/components/base-node/components/node-header';
import NodeSnapshot from 'components/canvas/components/nodes/components/node-snapshot';
import NodeContextMenu from 'components/canvas/components/nodes/components/base-node/components/node-context-menu';
import GlobalLinksIndicator from 'components/canvas/components/nodes/components/base-node/components/global-links-indicator';
import useNodeDimensionsOperations from 'components/canvas/hooks/use-node-dimensions-operations';

interface ImageNodeProps extends NodeProps {}

function ImageNode(props: ImageNodeProps) {
  const { node } = props;

  const { getNodeDimensionsByType } = useNodeDimensionsOperations();

  const { width, height } = getNodeDimensionsByType(node?.type);

  return (
    <Node {...props} width={width} height={height}>
      {() => {
        return (
          <>
            <NodeHeader
              x={0}
              offsetY={40}
              fill="#1C1B18"
              fontStyle="bold"
              text={node.name ?? ''}
              width={width - 30}
              isReference={node.isReference}
            />
            <GlobalLinksIndicator node={node} x={width} />
            <NodeSnapshot node={node} width={width} height={height} />

            {/* NodeContextMenu has to be last component in tree because of z index and how react-konva assigns it to elements */}
            <NodeContextMenu width={width} height={height} node={node} />
          </>
        );
      }}
    </Node>
  );
}

export default ImageNode;
